import { Component } from '@angular/core';

@Component({
  selector: 'hx-capability-strip',
  standalone: true,
  template: `
    <div class="strip">
      <div class="wrap">
        <span class="strip-item">AWS · Azure · GCP</span>
        <span class="strip-item">Payment Systems</span>
        <span class="strip-item">Custom Dashboards</span>
        <span class="strip-item">API &amp; Systems Integration</span>
        <span class="strip-item">24/7 Monitoring</span>
      </div>
    </div>
  `,
})
export class CapabilityStripComponent {}
